<nz-layout>
    <nz-header>
        <div class="app-header">
            <div class="app-header_logo">
                <img class="logo" src="../../../assets/header_logo.svg" />
            </div>
            <!-- <h1 class="logo">Visaka App Service</h1> -->
            <div class="app-header-description">
                <span nz-icon class="color_white px-12" nzType="question-circle"></span>
                <p nz-dropdown nzTrigger="click" nzMode="horizontal" class="user_title header-menu"
                    [nzDropdownMenu]="menus">
                    User Account
                    <span nz-icon nzType="down"></span>
                </p>
                <nz-dropdown-menu class="deropdown_downarrow" #menus="nzDropdownMenu">
                    <ul nz-menu>
                        <li nz-menu-item><span nz-icon nzType="user" nzTheme="outline" class="me-2"></span> Profile</li>
                        <li nz-menu-item><span nz-icon nzType="logout" nzTheme="outline" class="me-2"
                                (click)="userlogout()"></span>Logout</li>
                    </ul>
                </nz-dropdown-menu>
            </div>
        </div>
    </nz-header>
    <nz-layout>
        <nz-sider nzWidth="200px" nzTheme="light" class="app-layout">
            <ul nz-menu nzTheme="light" nzMode="inline" class="sider-menu">
                <ng-container *ngFor="let item of menu">
                    <ng-container *ngIf="!item.subMenuflag">
                        <li nz-menu-item nzIcon="form">
                            <a [routerLink]="item.link">{{ item.title }}</a>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="item.subMenuflag">
                        <li nz-submenu [nzTitle]="item.title" nzIcon="form">
                            <ul *ngFor="let submenu of item.SubMenu">
                                <li nz-menu-item nzMatchRouter>
                                    <a [routerLink]="submenu.link">{{ submenu.title }}</a>
                                </li>
                            </ul>
                        </li>
                    </ng-container>
                </ng-container>
            </ul>
        </nz-sider>
        <nz-layout class="inner-layout">
            <nz-content>
                <div class="inner-content bg-color">
                    <router-outlet></router-outlet>
                </div>
            </nz-content>
        </nz-layout>
    </nz-layout>
</nz-layout>